module.exports = __webpack_public_path__ + "img/collectif-auth-certificate-icon.ef7141a7.svg";